import { SubPageLayout } from "@/components/SubPageLayout";
import { SITE_IMAGES } from "@/lib/site-data";

export default function HasznaltPonyvak() {
  return (
    <SubPageLayout
      pageNumber="13"
      eyebrow="Használt ponyvák"
      title="Több száz darab raktáron, azonnal elvihető."
      intro="Mezőgazdasági, ipari és járműtakarásra: minőségi, átvizsgált használt kamionponyvák. Akciónk most: 10 db ponyva egyidejű vásárlása esetén egyet ajándékba adunk!"
      heroImage="/assets/gallery/palletways-01.jpg"
      bullets={[
        { title: "600–900 g/m²", text: "Erős, strapabíró PVC – nem barkácsáruházi 'egynyári' minőség." },
        { title: "Szakadásmentes", text: "Minden ponyvát átvizsgálunk, csak ép darabokat adunk át." },
        { title: "Méretre vágás", text: "Kérésre vágás, két ponyva összehegesztése, ringlizés." },
        { title: "Azonnal elvihető", text: "Nyitvatartási időben azonnal vihető – nem kell várni heteket." },
      ]}
      gallery={SITE_IMAGES.usedGallery}
    >
      <section className="py-16 md:py-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-block bg-[#EA580C] text-white px-8 py-6 rounded-lg font-heading shadow-2xl glow-pulse">
            <div className="text-xs uppercase tracking-[0.3em] text-white/80">
              Aktuális akció
            </div>
            <div className="mt-2 font-extrabold text-2xl md:text-4xl">
              10 db = 11 db
            </div>
            <div className="mt-1 text-sm text-white/90">
              10 azonos méretű ponyva egyidejű vásárlása esetén 1 db AJÁNDÉKBA.
            </div>
          </div>
          <p className="mt-8 text-sm text-gray-500 leading-relaxed max-w-2xl mx-auto">
            Pontos méreteket és aktuális készletet kérjen telefonon. A
            méretek ±10–15 cm-rel eltérhetnek. Átlag életkor 4–6 év.
            Ringlizés felárral kérhető.
          </p>
        </div>
      </section>
    </SubPageLayout>
  );
}
